import script from "./RequestDemo.vue?vue&type=script&setup=true&lang=js"
export * from "./RequestDemo.vue?vue&type=script&setup=true&lang=js"

import "./RequestDemo.vue?vue&type=style&index=0&id=4081c712&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4081c712"]])

export default __exports__